import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { WINDOW } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { Provider } from '@kr/models';
import { DictionariesStore } from '@kr/store';

import { UserCardComponent } from '../';
import { ShellStore } from '../../shell.store';
import { CompanySelectorComponent } from '../company-selector/company-selector.component';
import { TotalBalanceComponent } from '../total-balance/total-balance/total-balance.component';

@Component({
  imports: [TranslateModule, CompanySelectorComponent, UserCardComponent, TotalBalanceComponent],
  selector: 'kr-header, [krHeader]',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  readonly #shellStore = inject(ShellStore);
  readonly #dictionariesStore = inject(DictionariesStore);

  readonly #window = inject<Window>(WINDOW);

  readonly header = this.#shellStore.i18Header;
  readonly account = this.#shellStore.account;
  readonly totalBalances = this.#shellStore.totalBalances;

  readonly companies = this.#dictionariesStore.companyList;
  readonly currencies = this.#dictionariesStore.currencies;

  get selectedCompany(): string {
    return this.#dictionariesStore.getStoredOrgId();
  }

  changeCompany(companyId: string) {
    this.#dictionariesStore.storeOrgId(companyId);
    this.#dictionariesStore.setSelectedCompanyId(companyId);

    this.#window.location.reload();
  }

  changeCurrency(currencyId: number, provider: Provider) {
    this.#getTotalBalance(currencyId, provider);
  }

  #getTotalBalance(currency_id: number, provider: Provider): void {
    this.#shellStore.getTotalBalance({ params: { currency_id }, provider });
  }
}
